import { post } from '../axios'

const payBySpiceMoneyWallet = async (
  sessionId: string,
  amount: number,
  orderID: number,
) => {
  try {
    await post('/payment/v1/external-wallet/debit', {
      payment_mode_id: 13,
      session_id: sessionId,
      order_id: orderID,
      amount: amount,
    })
    return true
  } catch {
    return false
  }
}

export default payBySpiceMoneyWallet
